import colors from "styles/colors";
import styled from "styled-components";

export const BarText = styled.div.attrs((props) => ({
  color: props.color || colors.mainText,
}))`
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${(props) => props.color};
  padding-top: 1px;
`;
export const BarZone = styled.div.attrs((props) => ({
  width: props.width ? props.width + "%" : "100%",
}))`
  position: relative;
  display: flex;
  flex-direction: row;
  width: ${(props) => props.width};
  align-items: center;
  margin-top: ${(props) => (props.marginTop ? props.marginTop + "px" : "0px")};
`;
export const BarBorder = styled.div.attrs((props) => ({
  width: props.width ? props.width + "%" : "100%",
}))`
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  overflow: hidden;
  width: ${(props) => props.width};
  height: ${(props) => props.height + "px"};
`;
export const BarNumber = styled.div`
  margin-left: ${(props) => props.space + "px"};
  font-size: 10px;
  color: ${(props) => props.color};
`;
export const BarTextLeft = styled(BarText)`
  padding-left: ${(props) => props.space + "px"};
  padding-right: 8px;
`;
export const BarTextRight = styled(BarText)`
  width: 100%;
  padding-right: ${(props) => props.space + "px"};
  padding-left: 8px;
  text-align: end;
  overflow: visible;
`;
export const BarLeft = styled.div`
  flex: ${(props) => props.value1 / (props.value1 + props.value2) + 0.5};
  display: flex;
  background-color: ${(props) => props.bgColor};
  align-items: center;
  overflow: hidden;
  &:hover ${(props) => props.tooltip} {
    visibility: visible;
  }
`;
export const BarRight = styled.div`
  flex: ${(props) => props.value2 / (props.value1 + props.value2) + 0.5};
  background-color: ${(props) => props.bgColor};
  display: flex;
  align-items: center;
  overflow: hidden;
`;

//Line Bar Style
export const LineBar = styled.div`
  background-color: ${(props) => props.bgColor};
  flex: 1;
  display: flex;
  align-items: center;
`;
export const LineBarToolTipZone = styled.div`
  visibility: hidden;
  position: absolute;
  top: ${(props) => props.top + "px"};
  left: ${(props) => props.left + "px"};
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 30px;
  z-index: 9;
`;
export const LineBarToolTip = styled.div`
  background-color: ${(props) => props.bgColor || colors.tooltip};
  padding: 6px 8px;
  border-radius: ${(props) => props.radius || "3px"};
  color: ${(props) => props.color || colors.backgroundSection};
  font-size: ${(props) => props.fontSize || "7px"};
  font-weight: ${(props) => (props.bold ? 800 : 400)};
`;
export const LineBarToolTipArrow = styled.div`
  width: 0;
  height: 0;
  border-left: 3px solid transparent;
  border-right: 3px solid transparent;
  border-top: 3px solid ${(props) => props.bgColor || colors.tooltip};
`;

//Trending Bar Style
export const VerticalBarToolTipZone = styled.div`
  position: absolute;
  top: ${(props) => props.top + "px"};
  left: ${(props) => props.left + "px"};
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 30px;
`;
export const VerticalBarToolTip = styled.div`
  background-color: ${(props) => props.bgColor || colors.tooltip};
  padding: 6px 8px;
  border-radius: ${(props) => props.radius || "3px"};
  color: ${(props) => props.color || colors.backgroundSection};
  font-size: ${(props) => props.fontSize || "7px"};
  font-weight: ${(props) => (props.bold ? 800 : 400)};
`;
export const VerticalBarToolTipArrow = styled.div`
  width: 0;
  height: 0;
  border-left: 3px solid transparent;
  border-right: 3px solid transparent;
  border-top: 3px solid ${(props) => props.bgColor || colors.tooltip};
`;
